<template>
  <div class="InfoEdit">

    <div class="info_form">
      <van-form @submit="onSubmit(info_form)" :show-error="false" label-width="80" >

        <van-field
            readonly
            clickable
            name="relationshipName"
            :value="info_form.relationshipName"
            label="与本人关系"
            placeholder="请选择与本人的关系"
            @click="showPicker = true"
            :rules="[{ required: true, message: '请选择与本人的关系' }]"
        >
          <template #right-icon>
            <i class="iconfont icon-tiaozhuan" style="color: #3390F3; "></i>
          </template>
        </van-field>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
              show-toolbar
              value-key="dictValue"
              :columns="this.$store.state.rela"
              @confirm="onConfirm"
              @cancel="showPicker = false"
          />
        </van-popup>

        <van-field
            v-model="info_form.patientName"
            name="patientName"
            maxlength="10"
            label="就诊人姓名"
            placeholder="请输入就诊人姓名"
            :rules="[{ required: true, message: '请填写就诊人姓名' }]"
        />

        <van-field
            v-model="info_form.idCardNo"
            name="idCardNo"
            label="身份证号"
            placeholder="请输入就诊人身份证号"
            :rules="[{ required: true, message: '请填写就诊人身份证号' },{ pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '就诊人身份证号不正确' }]"
        />

        <van-field name="radio" label="性别">
          <template #input>
            <div
                v-if="info_form.gender === 0"
                style="width: 100%; display: flex; justify-content: flex-start;">
              女
            </div>
            <div
                v-else-if="info_form.gender === 1"
                style="width: 100%; display: flex; justify-content: flex-start;">
                男
            </div>
            <div
                v-else
                style="width: 100%; display: flex; justify-content: flex-start;">
              {{ info_form.gender }}
            </div>
          </template>
        </van-field>

        <van-field
            class="no_line"
            v-model="info_form.phoneNo"
            name="phoneNo"
            label="手机号"
            :disabled="info_form.relationship == '0'"
            placeholder="请输入就诊人手机号"
            :rules="[{ required: true, message: '请填写就诊人手机号' },( info_form.relationship == 0 ? {} : { pattern: /^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/, message: '就诊人手机号不正确' } )]"
        />

        <div class="buttons">
          <van-button round block :loading="loads" :disabled="loads" type="info" native-type="onSubmit">保存</van-button>
          <van-button v-if="this.$route.query.id"
                      round
                      block
                      native-type="button"
                      type="danger"
                      @click="del()" >删除</van-button>
        </div>

      </van-form>

    </div>


  </div>
</template>

<script>
export default {
  name: "InfoEdit",
  data() {
    return{
      info_form: {
        gender: null,
        idCardNo: null,
        patientName: null,
        phoneNo: null,
        relationship: null,
        relationshipName: null,
      },
      showPicker: false,
      loads: false
    }
  },
  watch: {
    info_form: {
      handler(newVal) {
        if(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(newVal.idCardNo)) {
          if((newVal.idCardNo[newVal.idCardNo.length-2] % 2) == 0 ) {
            this.info_form.gender= 0;
          }else {
            this.info_form.gender= 1;
          }
        }else {
          this.info_form.gender= "--";
        }

        if(newVal.relationship == '0') {
          newVal.phoneNo= this.$store.state.phoneNo;
        }


      },
      deep: true
    }
  },
  created() {
    this.getInfo();
    this.$store.dispatch("setRela");
    console.log(this.$store.state.rela)
    if(this.$route.query.id) {
      this.get_deta(this.$route.query.id)
    }
  },
  mounted() {

  },
  methods: {
    getInfo() {
      this.$get("user/basic")
          .then(res => {
            if(res) {
              console.log(res)
              this.$store.commit("setPhoneNo",res.data.phoneNo);
            }
          })
    },
    get_deta(y) {
      this.$get("patient/detail",y,true)
        .then(res => {
          if(res) {
            // console.log(res)
            this.info_form= res.data;
          }
        })
    },
    onSubmit(formName) {
      console.log(formName);

      this.loads= true;

      this.$put("patient",formName)
        .then(res => {
          if(res) {
            // this.$router.push({
            //   path: "/infoList"
            // })
            this.$router.go(-1);
            this.$toast.success("操作成功");
          }
          this.loads= false;
        })
        .catch(() => {
          this.loads= false;
        })
    },
    onConfirm(e) {
      console.log(e)
      this.info_form.relationship= e.dictKey;
      this.info_form.relationshipName= e.dictValue;
      this.showPicker= false;
      this.info_form.phoneNo= "";
    },
    del() {
      this.$dialog.confirm({
        message: '是否要删除该就诊人',
      })
          .then(() => {
            // on confirm
            this.$del("patient",this.$route.query.id,true)
                .then(res => {
                  if(res) {
                    console.log(res);
                    // this.$router.replace({
                    //   path: "/infoList"
                    // })
                    this.$router.go(-1);
                  }
                })
          })
          .catch(() => {
            // on cancel
          });
    }
  },
}
</script>

<style lang="less" scoped>
    @import "../../../style/My/Info/InfoEdit";
</style>
